import { FunctionComponent } from 'react'
import { FeedbackRefuseReservationModalProps } from './FeedbackRefuseReservationModal.types'
import { getTheme, Flex, Text, Space } from '@conexasaude/conexa-hero'
import Modal from '@/components/Modal'
import { useFeedbackRefuseReservationModal } from './FeedbackRefuseReservationModal.hook'
import { Illustration } from '@conexasaude/iconography/illustrations'
import { RenderIf } from '@/components/RenderIf'

export const FeedbackRefuseReservationModal: FunctionComponent<
  FeedbackRefuseReservationModalProps
> = props => {
  const theme = getTheme()
  const { actions, formatted, validations } =
    useFeedbackRefuseReservationModal(props)

  return (
    <Modal
      id="FEEDBACK_REFUSE_RESERVATION"
      title="Reserva recusada"
      primaryActionLabel={formatted?.primaryActionLabel}
      primaryAction={actions.handlePrimaryAction}
      {...(validations?.professionalServiceCanScheduleAttendance && {
        negativeActionLabel: 'Agora não',
        negativeAction: actions.handleCloseModal,
      })}
    >
      <Flex
        mt={theme.spacing.sm}
        mb={{ sm: theme.spacing.sm }}
        direction="column"
      >
        <Flex align="center" justify="center" pb={theme.spacing.xs}>
          <Illustration name="medic-error" width="168px" height="168px" />
        </Flex>

        <Text variant="paragraphLarge" color={theme.colors.neutral[400]}>
          O pré-agendamento foi cancelado com sucesso.
        </Text>

        <RenderIf
          condition={validations.professionalServiceCanScheduleAttendance}
        >
          <Space mt={theme.spacing.xs}>
            <Text
              variant="paragraphLarge"
              color={theme.colors.neutral[400]}
              fontWeight={500}
            >
              Deseja agendar um novo atendimento?
            </Text>
          </Space>
        </RenderIf>
      </Flex>
    </Modal>
  )
}
